import React, { useState } from "react";
import { FaLinkedin, FaTwitter, FaInstagram, FaCopy, FaHeadphonesAlt } from "react-icons/fa";

const HelpCenterModal = ({ isOpen, onClose }) => {
  const email = "support@codequeue.in";

  const handleCopy = () => {
    navigator.clipboard.writeText(email);
    alert("Email address copied to clipboard!");
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-[90%] sm:w-[40%] relative">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-800 text-lg"
        >
          ✕
        </button>

        {/* Modal Content */}
        <h2 className="text-2xl font-bold mb-4">Help Centre</h2>
        <p className="text-gray-700 mb-6">
          Facing any issues or want to connect with the community? Look no further
        </p>

        {/* Email Section */}
        <div className="flex flex-col sm:flex-row items-center justify-between border border-gray-300 rounded-md p-4 mb-6">
          <div className="flex items-center gap-2 w-full sm:w-auto">
            <FaHeadphonesAlt className="text-2xl text-gray-600" />
            <span className="text-gray-800 font-medium">{email}</span>
          </div>
          <button
            onClick={handleCopy}
            className="bg-gray-100 border border-gray-300 px-3 py-2 rounded text-sm font-medium flex items-center gap-1 hover:bg-gray-200 w-full sm:w-auto mt-2 sm:mt-0"
          >
            <FaCopy /> Copy
          </button>
        </div>

        {/* Social Media Links */}
        <div className="flex items-center justify-center gap-6 border-t pt-4">
          <a href="https://www.linkedin.com/company/code-queue/posts/?feedView=all&viewAsMember=true" className="text-gray-600 hover:text-gray-800 text-2xl" target="_blank">
            <FaLinkedin />
          </a>
          <a href="https://x.com/i/flow/login?redirect_after_login=%2Fssatyendrak13" className="text-gray-600 hover:text-gray-800 text-2xl" target="_blank">
            <FaTwitter />
          </a>
          <a href="https://www.instagram.com/codequeue.in/" className="text-gray-600 hover:text-gray-800 text-2xl" target="_blank">
            <FaInstagram />
          </a>
          <p className="text-gray-700 font-medium">Join the community</p>
        </div>
      </div>
    </div>
  );
};

const App = () => {
  const [isHelpCenterOpen, setHelpCenterOpen] = useState(false);

  return (
    <div className="p-6">
      {/* Help Center Link */}
      <button
        onClick={() => setHelpCenterOpen(true)}
        className="text-base text-gray-800 underline"
      >
        Help Centre
      </button>

      {/* Help Center Modal */}
      <HelpCenterModal
        isOpen={isHelpCenterOpen}
        onClose={() => setHelpCenterOpen(false)}
      />
    </div>
  );
};

export default HelpCenterModal;
